import {
  FETCH_MEMBERSHIP_REQUESTS_REQUEST,
  FETCH_MEMBERSHIP_REQUESTS_SUCCESS,
  FETCH_MEMBERSHIP_REQUESTS_FAILURE,
  FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST,
  FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS,
  FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE,
  DELETE_MEMBERSHIP_REQUEST_REQUEST,
  DELETE_MEMBERSHIP_REQUEST_SUCCESS,
  DELETE_MEMBERSHIP_REQUEST_FAILURE,
  CLEAR_MEMBERSHIP_REQUESTS_ERROR,
} from "../actions/membershipRequestActionTypes.js";

const initialState = {
  membershipRequests: [],
  membershipRequestDetails: null,
  isLoading: false,
  fetchMembershipRequestsError: null,
  fetchMembershipRequestDetailsError: null,
  deleteMembershipRequestError: null,
};

const membershipRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MEMBERSHIP_REQUESTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchMembershipRequestsError: null,
      };
    case FETCH_MEMBERSHIP_REQUESTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        membershipRequests: action.payload,
        fetchMembershipRequestsError: null,
      };
    case FETCH_MEMBERSHIP_REQUESTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchMembershipRequestsError: action.payload,
      };

    case FETCH_MEMBERSHIP_REQUEST_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        fetchMembershipRequestDetailsError: null,
      };
    case FETCH_MEMBERSHIP_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        membershipRequestDetails: action.payload,
        fetchMembershipRequestDetailsError: null,
      };
    case FETCH_MEMBERSHIP_REQUEST_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        fetchMembershipRequestDetailsError: action.payload,
      };

    case DELETE_MEMBERSHIP_REQUEST_REQUEST:
      return {
        ...state,
        isLoading: true,
        deleteMembershipRequestError: null,
      };
    case DELETE_MEMBERSHIP_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        membershipRequests: state.membershipRequests.filter(
          (request) => request.id !== action.payload,
        ),
        deleteMembershipRequestError: null,
      };
    case DELETE_MEMBERSHIP_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        deleteMembershipRequestError: action.payload,
      };

    case CLEAR_MEMBERSHIP_REQUESTS_ERROR:
      return {
        ...state,
        fetchMembershipRequestsError: null,
        fetchMembershipRequestDetailsError: null,
        deleteMembershipRequestError: null,
      };

    default:
      return state;
  }
};

export default membershipRequestReducer;
